import { MessageRecipients } from "../../../../../../../../components/Messages";

const ProxyMessageRecipients = () => {
  return <MessageRecipients />;
};

export default ProxyMessageRecipients;
